<template>
    <div class="flex min-h-screen flex-col items-center bg-zinc-100 pt-6 sm:justify-center sm:pt-0 dark:bg-zinc-900">
        <div class="w-full overflow-hidden bg-white px-6 py-4 shadow-md sm:max-w-md sm:rounded-lg dark:bg-zinc-800">
            <slot />
        </div>
    </div>
</template>
